export default __webpack_public_path__ + "static/media/176.352a4e8b.jpg";